import axios from "axios";
import qs from "qs";
import {
    v4 as uuidv4
} from 'uuid';
const initialState = {
	supportTicket: {
	},
	supportTickets: [],
	supportTicketsCount: 0,
    queryObject: {
        offset: 0,
		limit: 20
    }
};

export const state = { ...initialState };

export const actions = {
	async loadSupportTickets(context) {
		return axios.get("/api/support/tickets", {params: context.state.queryObject}).then(function(response){		
			console.log(response)
			context.commit("setSupportTickets",response.data.supportTickets);
			context.commit("setSupportTicketsCount",response.data.supportTicketsCount);
		})
	},

	async loadSupportTicket(context, id) {
		return axios.get("/api/support/ticket", {params:{id:id}}).then(function(response){
			
			context.commit("setSupportTicket",response.data);
		})
	},

	newSupportTicketWithID(context){
		var ticket = {
			ticket_id: uuidv4()
		}
		context.commit("setSupportTicket",ticket);
	},

	async createSupportTicket(context, ticket) {
		return axios.post("/api/support/ticket", ticket);
	},

	updateQuery(context,data){
        context.commit("setQuery",data);
    },
};

export const mutations = {
	setSupportTickets(state,data) {
		state.supportTickets = data;
	},
	setSupportTicketsCount(state,data) {
		state.supportTicketsCount = data;
	},
	setSupportTicket(state,data) {
		state.supportTicket = data;
	},
	setQuery(state,obj){
        state.queryObject=obj;
    },
};

const getters = {
	supportTicket(state){
		return state.supportTicket;
	},
	supportTickets(state){
		return state.supportTickets;
	},
	supportTicketsCount(state){
		return state.supportTicketsCount;
	}
};

export default {
    state,
    actions,
    mutations,
    getters
};
  